// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"268":"94af8966","829":"0a8371fc","879":"dc9ebf30"}[chunkId] + ".chunk.css";
};